
// export const logout = ( state ) => {
// }

export const setDealers = (state, dealers) => {
    state.dealers = dealers
}

export const setDealersSelectable = (state, dealers) => {
    state.dealersSelectable = dealers
}

export const setDealersPaginated = (state, dealersPaginatedData) => {
    state.dealersPaginatedData = dealersPaginatedData
}

export const setDealerDetail = (state, dealer) => {
    state.dealer = dealer
}

export const saveNewDealers = (state, dealer) => {
    state.dealers.unshift(dealer)
    state.createdData = dealer;
}

export const saveUpdatedDealer = (state, dealer) => {
    state.dealers.unshift(dealer)
    state.updatedData = dealer;
}

export const setDeleteDealer = (state, dealer) => {
    
    state.dealersPaginatedData.data.filter(x => x.id !== dealer.id);
    state.deletedData = dealer
}

export const setDealerIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setDealerIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setDealerIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setDealerIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
